import React, { useState } from 'react';

/**
 * Shown at the sign-in moment when we detect an in-app browser (WhatsApp/Cliq/etc.
 * WebView), where Zoho Embedded Auth loops because the WebView's cookie jar is isolated
 * from the real browser. Guides the user to reopen larynx in Chrome/Safari, where
 * sign-in completes in one pass. We warn rather than block (detection is conservative).
 */
export default function InAppBrowserNotice() {
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      /* clipboard unavailable — user can still use the ⋮ menu */
    }
  };

  return (
    <div
      className="rounded-xl p-4 mb-4 text-left"
      style={{ background: 'var(--color-warning-dim)', border: '1px solid var(--color-warning-border)' }}
    >
      <p className="text-sm font-semibold mb-1" style={{ color: 'var(--color-warning)' }}>
        Open in your browser to sign in
      </p>
      <p className="text-sm mb-3" style={{ color: 'var(--text-muted)' }}>
        You're in an app's built-in browser (e.g. WhatsApp), where Zoho sign-in can loop.
        Tap the <strong>⋮</strong> / <strong>share</strong> menu and choose{' '}
        <strong>“Open in Chrome”</strong> or <strong>“Open in browser”</strong>, then sign in there.
      </p>
      <button onClick={copyLink} className="btn-bouncy text-sm px-4 py-2">
        {copied ? 'Link copied ✓' : 'Copy link'}
      </button>
    </div>
  );
}
